import React from "react";

import { Box } from "@noom/wax-component-library";

type FadeProps = {
  children?: React.ReactNode;
  duration?: number;
  delay?: number;
  onAnimationEnd?: () => void;
};

export const FadeIn: React.FC<FadeProps> = ({
  children,
  duration = 2,
  delay = 1,
  onAnimationEnd,
}) => (
  <Box
    onAnimationEnd={onAnimationEnd}
    opacity={0}
    sx={{
      "@keyframes fadeIn": {
        from: { opacity: 0 },
        to: { opacity: 1 },
      },
      animation: `fadeIn ${duration}s ${delay}s forwards`,
    }}
  >
    {children}
  </Box>
);

export const FadeInAndOut: React.FC<FadeProps> = ({
  children,
  duration = 3,
  delay = 0,
  onAnimationEnd,
}) => (
  <Box
    onAnimationEnd={onAnimationEnd}
    opacity={0}
    sx={{
      "@keyframes fadeInAndOut": {
        "0%": { opacity: 0 },
        "25%": { opacity: 1 },
        "75%": { opacity: 1 },
        "100%": { opacity: 0 },
      },
      animation: `fadeInAndOut ${duration}s ${delay}s forwards`,
    }}
  >
    {children}
  </Box>
);

export const FadeOut: React.FC<FadeProps> = ({
  children,
  duration = 2,
  delay = 1,
  onAnimationEnd,
}) => (
  <Box
    onAnimationEnd={onAnimationEnd}
    sx={{
      "@keyframes fadeOut": {
        from: { opacity: 1 },
        to: { opacity: 0 },
      },
      animation: `fadeOut ${duration}s ${delay}s forwards`,
    }}
  >
    {children}
  </Box>
);
